import { render, staticRenderFns } from "./holeritePensionista.vue?vue&type=template&id=a76d6e58&"
import script from "./holeritePensionista.vue?vue&type=script&lang=js&"
export * from "./holeritePensionista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports